import axios, { AxiosError, CancelTokenSource , AxiosRequestConfig } from 'axios';
import { useEffect } from 'react';
import { API_V2 } from '../lib/axios/instances/API_V2';
import { ANALYTICS } from '../lib/axios/instances/Analytic';
import { Legacy } from '../lib/axios/instances/Legacy';

const useHTTPInterceptor = () => {
  let cancelTokenSource: CancelTokenSource | null = null;

  useEffect(() => {
    const apiv2InterceptorReqId = API_V2.interceptors.request.use(interceptAPIV2Request);
    const apiv2InterceptorResId = API_V2.interceptors.response.use((response) => response, handleResponseError);

    const analyticsInterceptorReqId = ANALYTICS.interceptors.request.use(interceptAnalyticsRequest);
    const analyticsInterceptorResId = ANALYTICS.interceptors.response.use((response) => response, handleResponseError);

    const legacyInterceptorReqId = Legacy.interceptors.request.use(interceptLegacyRequest);
    const legacyInterceptorResId = Legacy.interceptors.response.use((response) => response, handleResponseError);

    return () => {
      API_V2.interceptors.request.eject(apiv2InterceptorReqId);
      API_V2.interceptors.response.eject(apiv2InterceptorResId);

      ANALYTICS.interceptors.request.eject(analyticsInterceptorReqId);
      ANALYTICS.interceptors.response.eject(analyticsInterceptorResId);

      Legacy.interceptors.request.eject(legacyInterceptorReqId);
      Legacy.interceptors.response.eject(legacyInterceptorResId);
    };
  }, []);

  const interceptAPIV2Request = (request: AxiosRequestConfig) => {
    cancelTokenSource = axios.CancelToken.source();
    request.cancelToken = cancelTokenSource.token;
    return request;
  };

  const interceptAnalyticsRequest = (request: AxiosRequestConfig) => {
    return request;
  };

  const interceptLegacyRequest = (request: AxiosRequestConfig) => {
    return request;
  };

  const handleResponseError = (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      if (cancelTokenSource) {
        cancelTokenSource.cancel('Request canceled due to session expiration.');
      }
    }
    return Promise.reject(error);
  };
};

export default useHTTPInterceptor;
